import React from "react";
import {ImageInput} from '../../'
import { colors, getVal, makeArrayFromLength, LABEL } from "oolib";

export const ProfileImageInput = ({
  //props that pass on to ImageInput
  id,
  value,
  onChange,
  readOnly,
  invert,
  allowedFormats = ["jpg", "jpeg", "png"],
  disableImageBorder,
  defaultImageSpread="cover",
  containerShape="circle",

  //ProfileImageInput specific props
  size = 200, // Number > representing pixels
  imageTitle: _imageTitle,
  imageTitlePath,
  content : _content,
  
}) => {

  const content = _content
  
  let imageTitle =
    _imageTitle ||
    (imageTitlePath && getVal(content, imageTitlePath)) ||
    (value && value[0]?.publicUrl) ||
    "";

  let sizeString = size + "px";

  const calcPlaceholderInitialSize = (_size) => {
    let size = _size / 10; //cuz now we are using pixel size
    if (typeof size !== "number") return undefined;

    const inverseDecay = (size) => (1.2 / (size * size)) * 7;
    let textSize = 0;
    makeArrayFromLength(size).map((s) => {
      textSize = textSize + inverseDecay(s + 1);
    });

    return textSize + size / 2;
  };

  return (
    <div style={{ width: sizeString, height: sizeString }}>
      {
        //if edit mode then show imageinput
        //if readonly mode, then value has to exist for imageinput to show
        //the Array check is important so that string do that get accepted as value
        ((Array.isArray(value) && value?.length > 0) || !readOnly) ? (
          <ImageInput
            id={id}
            value={value}
            onChange={onChange}
            aspectRatio={"1/1"}
            containerShape={containerShape}
            enableCaptions={false}
            defaultImageSpread={defaultImageSpread}
            formatConvertConfig="noConversion"
            omitEditorTools={['cover_contain']}
            allowedFormats={allowedFormats}
            readOnly={readOnly}
            invert={invert}
            disableImageBorder={disableImageBorder}
          />
        ) : (
          <div
            style={{
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              backgroundColor: invert ? colors.greyColor80 : colors.greyColor100,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <LABEL
              style={{
                fontSize: calcPlaceholderInitialSize(size),
                fontWeight: 500,
                letterSpacing: 0,
              }}
              invert={true}
            >
              {imageTitle.charAt(0).toUpperCase()}
            </LABEL>
          </div>
        )
      }
    </div>
  );
};

